export const paymentStatuses = [
  "open",
  "complete",
  "expired",
  "uncaptured",
  "requires_action",
  "cancelled",
] as const;

export type PaymentStatus = (typeof paymentStatuses)[number];
